

export enum ProductFields {
    Id = 'Id',
    Name = 'Name',
    Thumbnail = 'Thumbnail',
    Url = 'Url',
    Description = 'Description',
    Prices = 'Prices',
    Stock = 'Stock',
    Tags = 'Tags',
    Categories = 'Categories',
    Variants = 'Variants',
    AllScores = 'AllScores',
    ContextualizedScores = 'ContextualizedScores',
    NameAndThumbnail = 'NameAndThumbnail',
    NameThumbnailAndCategories = 'NameThumbnailAndCategories',
    Standard = 'Standard',
    StandardWithAllScores = 'StandardWithAllScores',
    StandardWithContextualizedScores = 'StandardWithContextualizedScores',
    All = 'All'
}

export enum VisitorDevice {
    Desktop = 'Desktop',
    Tablet = 'Tablet',
    Mobile = 'Mobile',
}

export type SearchRequest = {
    searchTerm?: string,
    ids?: string[],
    requestedFields?: ProductFields[],
    scoreTenant?: string,
    scoreDevice?: VisitorDevice,
    offset?: number,
    limit?: number,
    category?: ProductRequestCategoryFilter;
}

export type ProductRequestStringAttributeFilter = {
    contains?: string;
    notContains?: string;
    equals?: string;
    notEquals?: string;
}

export type ProductRequestCategoryFilter = {
    type?: ProductRequestStringAttributeFilter;
    name?: ProductRequestStringAttributeFilter;
};

export type ProductRequestResult = {
    products: ProductRequestResultProduct[];
    offset: number;
    totalCount: number;
}

export type ProductCategory = {
    _type: string;
    _name: string;
    _value: string | null;
}
export type ProductTag = {
    name: string | null;
    value: string | null;
    fullString: string;
}
export type ProductVariant = {
    stockQuantity: number;
    productVariantId: string;
    productVariantLabel: string;
    price: number;
    url?: string;
}
export type ProductRequestResultProduct = {
    id: string;
    name?: string;
    description?: string;
    url?: string;
    urlThumbnail?: string;
    price?: number;
    unitPriceWithRebate?: number;
    globalStockQuantity?: number;
    categories?: ProductCategory[];
    tags?: ProductTag[];
    productVariants?: ProductVariant[];
}